/* ============================================================
   small talk city — infinite scroll

   Replaces the Scrollio app on collection and search pages.
   Drives off the page's OWN numbered pagination: if this script
   never runs, or fails partway, the page falls back to normal
   numbered pages. Nothing is ever hidden that a visitor could
   not otherwise reach.

   Runs on all screen sizes. To limit it to phones again, set
   MOBILE_ONLY to true.
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_ONLY = false;
  var MOBILE = '(max-width: 899px)';
  var GRID = 'ul.stc-grid, ul.collection-list';
  var PAGINATION = 'ul.pagination';
  var TRIGGER_DISTANCE = 600; // px below the fold
  var MAX_PAGES = 40; // hard stop; guards against an unexpected loop

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function pageOf(url) {
    var m = String(url).match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  // The next page is the one numbered current + 1. Matching on the number
  // rather than on link position means we can never walk backwards, and we
  // stop cleanly on the last page, where no such link exists.
  function findNext(paginationEl, currentPage) {
    if (!paginationEl) return null;
    var want = currentPage + 1;
    var links = paginationEl.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (href && pageOf(href) === want) return href;
    }
    return null;
  }

  function itemKey(li) {
    var a = li.querySelector('a[href]');
    if (!a) return null;
    return (a.getAttribute('href') || '').split('?')[0];
  }

  function each(list, fn) {
    Array.prototype.slice.call(list).forEach(fn);
  }

  ready(function init() {
    if (!window.fetch || !window.DOMParser) return;
    if (MOBILE_ONLY && !window.matchMedia(MOBILE).matches) return;

    var grid = document.querySelector(GRID);
    var pagination = document.querySelector(PAGINATION);
    if (!grid || !pagination) return;

    var nextUrl = findNext(pagination, pageOf(window.location.search));
    if (!nextUrl) return; // single page, or already on the last one

    var loading = false;
    var done = false;
    var pagesLoaded = 0;
    var seen = Object.create(null);

    each(grid.children, function (li) {
      var key = itemKey(li);
      if (key) seen[key] = true;
    });

    var paginationBar = (pagination.closest && pagination.closest('nav, div')) || pagination;
    paginationBar.style.display = 'none';

    var status = document.createElement('p');
    status.className = 'stc-scroll-status';
    status.setAttribute('role', 'status');

    var sentinel = document.createElement('div');
    sentinel.className = 'stc-scroll-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');

    grid.parentNode.insertBefore(status, grid.nextSibling);
    status.parentNode.insertBefore(sentinel, status);

    // Two independent triggers. IntersectionObserver is the efficient one,
    // but browsers park it while a tab is backgrounded, so a throttled
    // scroll listener backs it up. Both funnel through the same guard.
    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) maybeLoad();
        },
        { rootMargin: TRIGGER_DISTANCE + 'px' }
      );
      observer.observe(sentinel);
    }

    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        maybeLoad();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    function inRange() {
      return sentinel.getBoundingClientRect().top < window.innerHeight + TRIGGER_DISTANCE;
    }

    function maybeLoad() {
      if (done || loading || !inRange()) return;
      load();
    }

    function teardown() {
      done = true;
      loading = false;
      if (observer) observer.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }

    function finish(message) {
      teardown();
      status.textContent = message || '';
    }

    function bailToPagination() {
      // Never strand the visitor: put the real pagination back and stand down.
      teardown();
      if (status.parentNode) status.parentNode.removeChild(status);
      paginationBar.style.display = '';
    }

    function load() {
      if (pagesLoaded >= MAX_PAGES) return finish('');

      loading = true;
      var requested = pageOf(nextUrl);
      status.textContent = 'loading more';

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector(GRID);
          if (!newGrid || !newGrid.children.length) return finish('');

          var frag = document.createDocumentFragment();
          var added = 0;
          each(newGrid.children, function (li) {
            var key = itemKey(li);
            if (key && seen[key]) return;
            if (key) seen[key] = true;
            frag.appendChild(document.importNode(li, true));
            added++;
          });

          if (!added) return finish('');

          grid.appendChild(frag);
          pagesLoaded++;

          nextUrl = findNext(doc.querySelector(PAGINATION), requested);
          if (!nextUrl) return finish('that’s everything');

          status.textContent = '';
          loading = false;
          maybeLoad(); // short pages: keep going while the sentinel is in view
        })
        .catch(bailToPagination);
    }
  });
})();
